import { createApi } from '@reduxjs/toolkit/query/react'
import baseQuery from 'services'
import { IdParams } from 'types/api'
import { IInfoCenterNews, IInfoCenterNewsItem } from 'types/info-center/news'
import { IPaginationQueryInfo } from 'types/pagination'

export const infoCenterNewsApi = createApi({
  reducerPath: 'infoCenterNews',
  baseQuery,
  tagTypes: ['News'],
  endpoints: (builder) => ({
    news: builder.query<IInfoCenterNews, IPaginationQueryInfo>({
      query: (params) => {
        return {
          url: '/info-center/news',
          method: 'get',
          params,
        }
      },
      providesTags: ['News'],
    }),
    newsItem: builder.query<IInfoCenterNewsItem, IdParams>({
      query: ({ id }) => `/info-center/news/${id}`,
    }),
    deleteNews: builder.mutation<void, IdParams>({
      query: ({ id }) => ({
        url: `/info-center/news/${id}`,
        method: 'delete',
      }),
      invalidatesTags: ['News'],
    }),
    createNews: builder.mutation<void, Partial<IInfoCenterNewsItem>>({
      query: (body) => ({
        url: `/info-center/news`,
        body,
        method: 'post',
      }),
      invalidatesTags: ['News'],
    }),
  }),
})

export const { useNewsQuery, useNewsItemQuery, useDeleteNewsMutation, useCreateNewsMutation } =
  infoCenterNewsApi
